import apiClient from '../apiClient';
import { DELETE_TRANSPORTATION_UNIT_HEADER_URL } from '../apiUrl';

const deleteTransportationUnitHeaderApi = Id => {
  return apiClient.delete(DELETE_TRANSPORTATION_UNIT_HEADER_URL(Id));
};

export default deleteTransportationUnitHeaderApi;
